import React from "react";

import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import { ChevronLeft as ArrowBackIos } from "lucide-react";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		backgroundColor: theme.mode === 'light'
			? "rgba(255, 255, 255, 0.2) !important"
			: "rgba(10, 25, 41, 0.3) !important",
		backdropFilter: "blur(20px) saturate(1.4)",
		WebkitBackdropFilter: "blur(20px) saturate(1.4)",
		flex: "none",
		border: "none",
		height: "65px",
		zIndex: 2,
		"& .MuiIconButton-root": {
			color: theme.mode === 'light' ? "#555" : "#bbb",
			"&:hover": {
				backgroundColor: "transparent",
			},
		},
		"& .MuiButton-root": {
			color: theme.mode === 'light' ? "#555" : "#bbb",
			"&:hover": {
				backgroundColor: "transparent",
			},
		},
		[theme.breakpoints.down("sm")]: {
			flexWrap: "nowrap",
			height: 48,
		},
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {
		history.push("/tickets");
	};

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<div className={classes.ticketHeader}>
					<Button onClick={handleBack} style={{ minWidth: 40 }}>
						<ArrowBackIos size={18} />
					</Button>
					{children}
				</div>
			)}
		</>
	);
};

export default TicketHeader;
